import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=10d40d2e&scoped=true"
import script from "./indexPage.vue?vue&type=script&lang=js"
export * from "./indexPage.vue?vue&type=script&lang=js"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=10d40d2e&prod&lang=less"
import style1 from "./indexPage.vue?vue&type=style&index=1&id=10d40d2e&prod&scoped=true&lang=css"
import style2 from "./indexPage.vue?vue&type=style&index=2&id=10d40d2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d40d2e",
  null
  
)

export default component.exports